import { render, staticRenderFns } from "./SwapAddressSelector.vue?vue&type=template&id=240d35f2&scoped=true&"
import script from "./SwapAddressSelector.vue?vue&type=script&lang=js&"
export * from "./SwapAddressSelector.vue?vue&type=script&lang=js&"
import style0 from "./SwapAddressSelector.vue?vue&type=style&index=0&id=240d35f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d35f2",
  null
  
)

export default component.exports